import React from 'react';

const NumericButton = (props) => {
    const { value, radio } = props;
    return (
        <button
            type="button"
            className="col-sm-3 btn_tel_chiffre m-1"
            onClick={() => radio.pressButton(value)}
        >
            {value}
        </button>
    );
};

export default NumericButton;
